export const bestCoupon = user =>
  user.coupons.length > 0
    ? [...user.coupons].sort(
        (a, b) => parseFloat(b.discount_in_hkd) - parseFloat(a.discount_in_hkd)
      )[0]
    : null;
